import { useEffect } from 'react';
import { useStore } from 'zustand';

import { EnquiriesSearchStore } from 'Features/SellerCommunications/services';
import { triggerSellerMessagingSearchClearClickedEvent } from 'Services/analytics/events';

export const useClearButtonEventTrigger = () => {
	const hasKeyword = useStore(EnquiriesSearchStore, (state) => !!state.keyword);

	useEffect(() => {
		const clearButton = document.querySelector('[aria-label="Clear search input"]');

		clearButton?.addEventListener('click', triggerSellerMessagingSearchClearClickedEvent);

		return () => {
			clearButton?.removeEventListener('click', triggerSellerMessagingSearchClearClickedEvent);
		};
	}, [hasKeyword]);
};
